import { TipSection, TipType } from '../models/reduction-tip';

/** Stats category each tip type is listed under on the impact page. */
export const TIP_SECTION: Record<TipType, TipSection> = {
  transport_alternative: 'transport',
  direct_flight: 'transport',
  eco_accommodation: 'accommodation',
  high_emission_activity: 'activities',
  trip_duration: 'ecoScore',
};

/** Heading of each section's tips card, reusing the stats heading above it. */
export const TIP_SECTION_LABEL_KEY: Record<TipSection, string> = {
  transport: 'impact.categories.transport',
  accommodation: 'impact.categories.accommodation',
  activities: 'impact.categories.activities',
  ecoScore: 'impactReport.ecoScore',
};
